import React from "react";
import submit from "submit-form";
import SvgIcon from "../../../../parts/SvgIcon";
import { useTranslation } from "react-i18next";

const ManageCategories = ({
  category,
  filteredProgramsLength = 0,
  selectedCategoryIndex,
  deleteCategory,
  currentTab,
}) => {
  const { t } = useTranslation("coaching-portal");
  const nameForPrograms = {
    programs: t("store.manageCategories.programs"),
    teams: t("store.manageCategories.teams"),
    "single-workout": t("store.manageCategories.singleWorkouts"),
  };

  return (
    <hgroup className="group-content">
      <div className="mobile-hidden">
        <h3>{category === "Uncategorized" ? t("store.uncategorized") : category}</h3>
        <p className="p5">
          ({filteredProgramsLength}) {nameForPrograms[currentTab]}
        </p>
      </div>
      <div className="mobile-hidden">
        {category !== "Uncategorized" ? (
          <>
            <button
              data-button-type="secondary"
              data-icon
              onClick={() => {
                submit("/actions/refresh?", {
                  method: "GET",
                  body: {
                    "modal[type]": "manage-categories",
                    storeType: currentTab,
                  },
                });
              }}
            >
              <SvgIcon src="/img/new-icons/manage.svg" />
              {t("store.manageCategories.manage")}
            </button>
            <button
              data-button-type="secondary"
              data-action="delete"
              onClick={() => deleteCategory(selectedCategoryIndex)}
            >
              <SvgIcon
                src="/img/svg/trash-alt.svg"
                alt={t("store.manageCategories.deleteAlt")}
                noFilterOnLight={true}
              />
              {t("store.manageCategories.deleteCategory")}
            </button>
          </>
        ) : null}
      </div>
    </hgroup>
  );
};

export default ManageCategories;
